// extracted by mini-css-extract-plugin
export default {"toggle":"MobileOrdering_toggle__ND-TJ","singleCheckPos":"MobileOrdering_singleCheckPos__vbznr","itemCommentsCharLimits":"MobileOrdering_itemCommentsCharLimits__jc2R-"};